/* @license react-google-recaptcha-ultimate v1.2.2 */
import{useLayoutEffect as e,useEffect as o}from"react";var r="undefined"!=typeof window?e:o;export{r as useIsomorphicLayoutEffect};
//# sourceMappingURL=useIsomorphicLayoutEffect.js.map
